import { css } from '../../lib/css'
import { useT } from '../../i18n'

// "The gap we fill" — Maya House's thesis: housing holds when the foundation
// (income, savings, skills, support) underneath it does. Three model pillars.
const PILLARS = [
  {
    head: 'Time-limited housing',
    desc: 'A stable base for about 9 to 15 months, with up to 24 when circumstances require.',
  },
  {
    head: 'Economic mobility',
    desc: 'Income development, financial capability, and KEYS matched savings toward permanent housing.',
  },
  {
    head: 'Individualized support',
    desc: 'Stabilization planning, housing navigation, and preparation for permanent housing.',
  },
]

export default function GapWeFill() {
  const t = useT()
  return (
    <div
      data-reveal="1"
      style={css(
        `padding: 96px clamp(20px, calc((100% - 1240px) / 2), 480px); display: grid; grid-template-columns: 1.1fr .9fr; gap: 56px; align-items: start; border-bottom: 1px solid #c4e2e7`,
      )}
    >
      <div style={css(`display: flex; flex-direction: column; gap: 22px`)}>
        <div style={css(`font-family: 'JetBrains Mono', monospace; font-size: 11px; letter-spacing: .14em; text-transform: uppercase; color: #0f8d80`)}>{t(`The gap we fill`)}</div>
        <h2 style={css(`margin: 0; font-family: Newsreader, Georgia, serif; font-size: clamp(32px, 3.6vw, 50px); line-height: 1.08; font-weight: 400; letter-spacing: -.02em; max-width: 18ch`)}>{t(`Housing holds when the foundation underneath it does.`)}</h2>
        <p style={css(`margin: 0; font-size: 17px; line-height: 1.7; color: #42596b; max-width: 54ch`)}>{t(`Many people experiencing homelessness or housing instability need more than a door. They need the income, savings, skills, and support to keep housing over time. Without that foundation in the first months, a placement often does not last. Maya House is the structured bridge in between, about 9 to 15 months where a placement becomes housing that holds.`)}</p>
      </div>
      <div style={css(`display: flex; flex-direction: column; gap: 18px`)}>
        {PILLARS.map((p, i) => (
          <div key={i} style={css(`border: 1px solid #c4e2e7; border-radius: 8px; padding: 24px 24px; background: #d9eef2; display: flex; flex-direction: column; gap: 8px`)}>
            <div style={css(`font-family: Newsreader, Georgia, serif; font-size: 24px; line-height: 1.1; color: #16233c; letter-spacing: -.01em`)}>{t(p.head)}</div>
            <p style={css(`margin: 0; font-size: 15.5px; line-height: 1.55; color: #33495c`)}>{t(p.desc)}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
